import {debounce} from "../../js/Util";

let otherServicesSlider;

const onResizeServicesSlider = debounce(() => {
    // Если не мобила, то строим слайдер
    if (App.W.outerWidth() > 767) {
        if (!otherServicesSlider) {
            otherServicesSlider = new Swiper('.js-other-services', {
                slidesPerView: "auto",
                spaceBetween: 0,
                navigation: {
                    nextEl: '.js-other-services-next',
                    prevEl: '.js-other-services-prev',
                },
                breakpoints: {
                    1140: {
                        slidesPerView: 3
                    },
                },
            });
        }
    } else {
        // Для мобилок дестроим слайдер, там он не нужен
        if (otherServicesSlider) {
            otherServicesSlider.destroy();
            otherServicesSlider = null;
        }
    }
}, 300);


if ($('.js-other-services').length) {
    App.W.on('resize.services', () => {
        onResizeServicesSlider();
    });

    onResizeServicesSlider();
}
